module.exports = __webpack_public_path__ + "img/update-white.2f5d37ef.svg";